import SubAccountDetailsView from '@/subaccount/SubAccountDetailsView.vue'
import AccountsPayable from '@/subaccount/outstandingBalance/AccountsPayable.vue'
import AccountsReceivable from '@/subaccount/outstandingBalance/AccountsReceivable.vue'
import SaccImportView from '@/subaccount/SaccImportView.vue'
import CustomerAgeDividedReportView from '@/subaccount/CustomerAgeDividedReportView.vue'
import SupplierAgeDividedReportView from '@/subaccount/SupplierAgeDividedReportView.vue'
import CustomersView from '@/subaccount/CustomersView.vue'
import SuppliersView from '@/subaccount/SuppliersView.vue'
import { PanelContent } from '@tritt/multipanel'

export const CUSTOMERS: PanelContent = { componentName: 'Customers', path: '/customers', component: CustomersView, meta: { requiresOrg: true } }

export const SUPPLIERS: PanelContent = { componentName: 'Suppliers', path: '/suppliers', component: SuppliersView, meta: { requiresOrg: true } }

export const SUBACC_DETAILS: PanelContent = {
    componentName: 'SubAccountDetails',
    path: '/subaccount/:subAccountUuid',
    component: SubAccountDetailsView,
    meta: { requiresOrg: true }
}

export const ACCOUNTS_RECEIVABLE = {
    componentName: 'AccountsReceivable',
    component: AccountsReceivable,
    meta: { requiresOrg: true }
}

export const ACCOUNTS_PAYABLE = {
    componentName: 'AccountsPayable',
    component: AccountsPayable,
    meta: { requiresOrg: true }
}

export const SACC_IMPORT: PanelContent = {
    componentName: 'SaccImport',
    path: '/subaccount/import',
    component: SaccImportView,
    meta: { requiresOrg: true }
}

export const CUSTOMER_AGE_DIVIDED_REPORT: PanelContent = {
    componentName: 'CustomerAgeDividedReport',
    path: '/customer/age-divided-report',
    component: CustomerAgeDividedReportView,
    meta: { requiresOrg: true }
}

export const SUPPLIER_AGE_DIVIDED_REPORT: PanelContent = {
    componentName: 'SupplierAgeDividedReport',
    path: '/supplier/age-divided-report',
    component: SupplierAgeDividedReportView,
    meta: { requiresOrg: true }
}